/**
 * Respiratory Examination Data Points
 * Category: Respiratory
 */

export const respiratoryDataPoints = [
  // Respiratory Distress
  {
    id: 'respiratory_distress',
    label: 'Respiratory distress',
    category: 'Respiratory',
    subcategory: 'Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for presence of respiratory distress'
    },
    code: '271825005', // SNOMED CT - Respiratory distress
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Chest Wall Tenderness
  {
    id: 'chest_wall_tenderness',
    label: 'Chest wall tenderness',
    category: 'Respiratory',
    subcategory: 'Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for chest wall tenderness on palpation'
    },
    code: '279039007', // SNOMED CT - Chest wall tenderness
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Trachea
  {
    id: 'trachea',
    label: 'Trachea',
    category: 'Respiratory',
    subcategory: 'Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Central', 'Displaced'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Assessment of tracheal position'
    },
    code: '44567001', // SNOMED CT - Tracheal structure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Expansion
  {
    id: 'expansion',
    label: 'Expansion',
    category: 'Respiratory',
    subcategory: 'Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Symmetrical', 'Asymmetrical'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Assessment of chest expansion'
    },
    code: '301284009', // SNOMED CT - Chest expansion
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Breath Sounds
  {
    id: 'breath_sounds',
    label: 'Breath sounds',
    category: 'Respiratory',
    subcategory: 'Assessment',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Wheezes', 'Ronchi', 'Creps'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Auscultation findings of breath sounds'
    },
    code: '76692003', // SNOMED CT - Breath sounds
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default respiratoryDataPoints
